/* eslint-disable default-param-last */
import concat from 'lodash/concat'
import { UPDATE_ENCOUNTER_CONDITIONS } from './condition'

export const UPDATE_LIST = 'ENCOUNTER_UPDATE_LIST'
export const APPEND_LIST = 'ENCOUNTER_APPEND_LIST'
export const UPDATE_PDF_LIST = 'ENCOUNTER_UPDATE_PDF_LIST'
export const CLEAR_PDF_LIST = 'ENCOUNTER_CLEAR_PDF_LIST'
export const UPDATE_SELECTED = 'ENCOUNTER_UPDATE_SELECTED'
export const UPDATE_RAF = 'ENCOUNTER_UPDATE_RAF'

export const PDF_READY = 'ENCOUNTER_PDF_READY'

export const CLEAR_STATE = 'ENCOUNTER_CLEAR_STATE'
export const CLEAR_ALL_STATE = 'CLEAR_ALL_STATE'
export const UPDATE_PAGES_SEEN = 'ENCOUNTER_UPDATE_PAGES_SEEN'

type EncounterItem = Record<string, unknown>

type SelectedEncounter = {
  conditions?: unknown[]
  raf?: unknown
  [key: string]: unknown
}

type EncounterState = {
  selected: SelectedEncounter
  list: EncounterItem[]
  onSchedule: boolean
  pdfList: EncounterItem[]
  pdfReady: boolean
  physicianDay: string | undefined
  pagesSeen: number
}

type Action = {
  type: string
  payload?: any
}

const initState: EncounterState = {
  selected: {},
  list: [],
  onSchedule: false,
  pdfList: [],
  pdfReady: false,
  physicianDay: undefined,
  pagesSeen: 1
}

export default (
  state: EncounterState = initState,
  action: Action
): EncounterState => {
  switch (action.type) {
    case CLEAR_STATE:
    case CLEAR_ALL_STATE:
      return initState

    case UPDATE_LIST:
      return {
        ...state,
        list: action.payload.list,
        onSchedule: action.payload.onSchedule,
        physicianDay: action.payload.physicianDay
      }

    case APPEND_LIST: {
      const newList = concat(
        state.list,
        action.payload
      )
      return {
        ...state,
        list: newList
      }
    }

    case UPDATE_PDF_LIST:
      return {
        ...state,
        pdfList: concat(
          state.pdfList,
          action.payload
        )
      }

    case CLEAR_PDF_LIST:
      return {
        ...state,
        pdfList: [],
        pdfReady: false
      }

    case UPDATE_SELECTED:
      return {
        ...state,
        selected: action.payload
      }

    case UPDATE_ENCOUNTER_CONDITIONS:
      return {
        ...state,
        selected: {
          ...state.selected,
          conditions: action.payload
        }
      }

    case PDF_READY:
      return {
        ...state,
        pdfReady: action.payload
      }

    case UPDATE_RAF:
      return {
        ...state,
        selected: {
          ...state.selected,
          raf: action.payload
        }
      }

    case UPDATE_PAGES_SEEN:
      return {
        ...state,
        pagesSeen: action.payload
      }

    default:
      return state
  }
}
